import { Component } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { appInjector } from '../app-injector';
import { BaseComponent } from '../base-component';
import { ErrorModalComponent } from '../error-modal/error-modal.component';
import { LanguageService } from '../services/language.service';

@Component({
  selector: 'app-number-conflict-modal',
  templateUrl: './number-conflict-modal.component.html',
  styleUrls: ['./number-conflict-modal.component.css']
})
export class NumberConflictModalComponent extends BaseComponent {
  constructor(
    private langService: LanguageService,
    public modal: BsModalRef,
  ) {
    super();
  }

  zipCode: string;

  async search() {
    try {
      await this.sesion.searchExpedition(this.sesion.numeroExpedicionBuscado, this.zipCode);
      this.modal.hide();
    } catch (err) {
      ErrorModalComponent.show(err);
    }
  }

  static show() {
    const modalService = appInjector.get(BsModalService);

    modalService.show(NumberConflictModalComponent);
  }
  get messageNumberConflict(): string {
    return this.langService.instant('Shared.ExpeditionNumberConflictInfo') ? this.langService.instant('Shared.ExpeditionNumberConflictInfo').replace('#number', this.sesion.numeroExpedicionBuscado) : '';
  }
}
